import {useMemo} from 'react';

import {useGetCourseEnrollmentsByCourseIdsQuery} from 'src/generated/graphql';

export function useCourseProgressById(courseIds: string[], enabled: boolean) {
    const shouldFetchProgress = enabled && courseIds.length > 0;
    const courseEnrollmentQuery = useGetCourseEnrollmentsByCourseIdsQuery(
        {courseIds},
        {enabled: shouldFetchProgress},
    );

    const courseProgressById = useMemo(() => {
        const enrollments =
            courseEnrollmentQuery.data?.me?.enrollments?.courseEnrollmentsForCourseIds ?? [];
        return enrollments.reduce<Record<string, number>>((acc, enrollment) => {
            if (!enrollment?.course?.id) {
                return acc;
            }
            if (typeof enrollment.completionPercentage === 'number') {
                acc[enrollment.course.id] = enrollment.completionPercentage;
            }
            return acc;
        }, {});
    }, [courseEnrollmentQuery.data]);

    return {courseProgressById, query: courseEnrollmentQuery};
}
